import { Injectable } from '@angular/core';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { CompanyFortnoxConfigCommandHandler } from './company-fortnox-config-command-handler.service';
import { companyCommand } from '../../command/company.command';
import { CompanyVismaConfigCommandHandler } from './company-visma-config-command-handler.service';

@Injectable()
export class CompanyFormCommandHandlerResolver extends FormCommandHandlerResolver {
  constructor(
    fortnoxConfigHandler: CompanyFortnoxConfigCommandHandler,
    vismaConfigHandler: CompanyVismaConfigCommandHandler,
    createHandler: CreateCommandHandler,
    deleteHandler: DeleteFormCommandHandler
  ) {
    super(createHandler, deleteHandler);
    this.addHandler(companyCommand.fortnoxConfig, fortnoxConfigHandler);
    this.addHandler(companyCommand.vismaConfig, vismaConfigHandler);
  }
}
